import React, {useCallback} from 'react';

import {BulkActionFooter} from 'src/components/bulk-tool/bulk-action-footer';

import Button from '@pb/kit-component-button';
import {DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';

import {ROLE_MODAL_TITLES} from '../constants';

import type {ProcessBulkAction} from 'src/components/bulk-tool/typedef';
import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';
import type {BulkUpdateAdminRoleRequest} from 'src/openapi/admin/models/BulkUpdateAdminRoleRequest';

type Props = {
    userIds: number[],
    onCloseModal: (submit: boolean) => void,
    processAction: ProcessBulkAction<BulkUpdateAdminRoleRequest>,
};

const MODAL_WIDTH = 600;

export const UnassignFromRoleModal = ({userIds, onCloseModal, processAction}: Props) => {
    const updateGroup = useCallback(async (options?: ActionOptions) => {
        return await processAction({usersIds: userIds}, options);
    }, [userIds, processAction]);

    return (
        <>
            <DialogHeader onClose={() => onCloseModal(false)}>
                {ROLE_MODAL_TITLES.UNASSIGN}
            </DialogHeader>
            <DialogMain style={{padding: 24, maxWidth: MODAL_WIDTH}}>
                {pluralize('Are you sure you want to unassign the selected user[s] from role?', userIds.length)}
            </DialogMain>
            <BulkActionFooter action="Unassign" onConfirm={updateGroup}>
                <Group>

                    <Button variant="Type.SECONDARY" onClick={() => onCloseModal(false)}>
                        Cancel
                    </Button>
                </Group>
            </BulkActionFooter>
        </>
    );
};
